import { Card, Grid, Text } from '@mantine/core';
import { DocumentAssetIcon } from './AssetsCards';

const AssetPickerCard = ({ asset, addAsset }) => {
  return (
    <Card key={asset.id} style={{ cursor: 'pointer' }} mb="lg" component="a" onClick={() => addAsset(asset)} withBorder>
      <Card.Section ta="left" bg="white" inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 5 }}>
            <div>
              {asset.type?.startsWith('image') === false ? (
                <DocumentAssetIcon assetType={asset.type} size={64} />
              ) : (
                <img alt="thumb" src={asset.thumbUrl} style={{ marginBottom: 'var(--mantine-spacing-sm)' }} />
              )}
            </div>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <div>
              <Text size="sm" c="dimmed">
                Title:
              </Text>
              <Text size="sm" c="dimmed">
                {asset.title}
              </Text>
            </div>
            <div>
              <Text size="sm" c="dimmed">
                Description:
              </Text>
              <Text size="sm" c="dimmed">
                {asset.description}
              </Text>
            </div>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <div>
              <Text size="sm" c="dimmed">
                Date Created:
              </Text>
              <Text size="sm" c="dimmed">
                {new Date(asset.createdAt).toLocaleString()}
              </Text>
            </div>
            <div>
              <Text size="sm" c="dimmed">
                Date Updated:
              </Text>
              <Text size="sm" c="dimmed">
                {new Date(asset.updatedAt).toLocaleString()}
              </Text>
            </div>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default AssetPickerCard;
